// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header     from './components/Header.jsx';
import Hero       from './components/Hero.jsx';
import About      from './components/About.jsx';
import OrderForm  from './components/OrderForm.jsx';
import Footer     from './components/Footer.jsx';
import ChatWidget from './components/ChatWidget.jsx';
import CakeDetail from './components/ClassicNapi.jsx';
import CakeDetailLingon from './components/LingonNapoleon.jsx';
import CakeDetailCurrant from './components/CurrantNapoleon.jsx';
import CakeDetailCran from './components/CranNapoleon.jsx';
import CakeDetailRasp from './components/RaspNapoleon.jsx';
import CakeDetailMix from './components/MixNapoleon.jsx';


function App() {
  return (
    <BrowserRouter>
      {/* Шапка и навигация рисуются везде */}
      <Header />

      {/* Основной контент меняется в зависимости от маршрута */}
      <Routes>
        {/* Главная страница: герой, галерея и форма */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <About />
              <OrderForm />
            </>
          }
        />

        {/* Отдельная страница торта */}
        <Route path="/cake/classic" element={<CakeDetail />} />
        <Route path="/cake/lingon" element={<CakeDetailLingon />} />
        <Route path="/cake/currant" element={<CakeDetailCurrant />} />
        <Route path="/cake/cranberry" element={<CakeDetailCran />} />
        <Route path="/cake/raspberry" element={<CakeDetailRasp />} />
        <Route path="/cake/mix" element={<CakeDetailMix />} />
      </Routes>

      {/* Подвал и виджет чата — тоже показываем всегда */}
      <Footer />
      <ChatWidget />
    </BrowserRouter>
  );
}

export default App;
